export default __webpack_public_path__ + "static/media/confirmationLottie.f32f0e40.svg";